module.exports = function (original, filter) {
  const obj = {}
  filter = filter || function (k, v) { return true }
  Object.keys(original || {}).forEach(function (key) {
    if (filter(key, original[key])) {
      obj[key] = original[key]
    }
  })
  return obj
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/yargs/lib/obj-filter.js
// module id = 67
// module chunks = 0